// PrivacyPolicy.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

export default function PrivacyPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = 'Privacy Policy | QRmor';
        const metaDesc = document.querySelector('meta[name="description"]');
        const content = 'Privacy Policy for QRmor, the non-clonable, anti-counterfeit QR code authentication platform from Scinova Scientifics.';
        if (metaDesc) {
            metaDesc.setAttribute('content', content);
        } else {
            const tag = document.createElement('meta');
            tag.name = 'description';
            tag.content = content;
            document.head.appendChild(tag);
        }
    }, [])
    return (
        <>
            <header>
                <nav className="wrap">
                    <div className="brand">
                        <img src="/assets/QRmor.png" alt="QRmor logo" />
                    </div>
                    <Link to="/" className="btn btn-primary btn-sm">Back to home</Link>
                </nav>
            </header>

            <section>
                <div className="wrap legal-content" style={{ maxWidth: 860, padding: '48px 32px 80px' }}>
                    <span className="eyebrow">Legal</span>
                    <h1 style={{ fontSize: 'clamp(28px, 4vw, 40px)', marginTop: 12, marginBottom: 8 }}>
                        Privacy Policy
                    </h1>
                    <p style={{ color: 'var(--ink-soft)', fontSize: 14, marginBottom: 36 }}>
                        Last updated: 18 August 2026
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
                        <div>
                            <h3>Overview</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                This policy explains what information Scinova Scientifics collects through the
                                QRmor website and Service, why we collect it, and how it's used. It applies to
                                visitors to this website and to end users who scan a QRmor code.
                            </p>
                        </div>

                        <div>
                            <h3>1. Information we collect</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                <b>Demo requests:</b> when you submit the "Request a demo" form, we collect your
                                name, email address, phone number, company name, and any message you provide.
                                <br /><br />
                                <b>Scan / verification data:</b> when a QRmor code is scanned, we log the scan
                                result (genuine or flagged), timestamp, and Geo location of scanning device at the time of verification only. The collected data is used for analytics and build verification
                                maps and alert the brands for any potential spurious activity.
                            </p>
                        </div>

                        <div>
                            <h3>2. How we use information</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                We use demo request details to respond to your inquiry and follow up about
                                QRmor. We use scan data to power authentication results, flag suspected clones,
                                and provide brands with audit trails and dashboards for their licensed SKUs.
                            </p>
                        </div>

                        <div>
                            <h3>3. Third-party services</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                We use EmailJS to deliver demo request submissions to our team, and OpenStreetMap
                                tile services to render the verification map shown on this site. These providers
                                process the minimum data necessary to perform that function on our behalf.
                            </p>
                        </div>

                        <div>
                            <h3>4. Data retention</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                We retain demo request and verification/scan data for as long as needed to
                                provide the Service, maintain audit trails for compliance purposes, and satisfy
                                legal or regulatory retention requirements.
                            </p>
                        </div>

                        <div>
                            <h3>5. Data sharing</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                We do not sell personal information. Verification and scan data tied to a
                                licensed SKU is shared with the brand that holds that license, so they can
                                monitor authenticity activity for their own products.
                            </p>
                        </div>

                        <div>
                            <h3>6. Your choices</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                You can request access to, correction of, or deletion of personal information
                                you've submitted to us (for example, through the demo request form) by
                                contacting us at the address below, subject to any retention we're required to
                                keep for compliance reasons.
                            </p>
                        </div>

                        <div>
                            <h3>7. Security</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                We use reasonable technical and organizational measures to protect the
                                information we collect. No system is completely secure, and we cannot guarantee
                                absolute security.
                            </p>
                        </div>

                        <div>
                            <h3>8. Changes to this policy</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                We may update this Privacy Policy from time to time. The "Last updated" date at
                                the top reflects the most recent revision.
                            </p>
                        </div>

                        <div>
                            <h3>9. Contact</h3>
                            <p style={{ color: 'var(--ink-soft)', marginTop: 8 }}>
                                For privacy questions or requests, contact us at{' '}
                                <a href="mailto:contact@qrmor.com" style={{ color: 'var(--crimson-deep)', fontWeight: 700 }}>
                                    contact@qrmor.com
                                </a>{' '}
                                or call{' '}
                                <a href="tel:+919974051262" style={{ color: 'var(--crimson-deep)', fontWeight: 700 }}>
                                    +91-9974051262
                                </a>.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}